import { MyAppointments_i18n } from "../../models/MyAppointments.i18n";

const myappointments_es: MyAppointments_i18n = {
    my_header: 'Bienvenido/a {{name}}, a continuación sus próximas citas:', 
    my_history: 'Historial', 
    my_nextAppointments: 'Próximas citas', 
    my_newAppointmentButton: 'Agendar Nueva Cita'
}

export default myappointments_es